import lodash from "lodash";
import ApiService from '~/services/api.service';
import FormResponseService from "~/services/form_response.service";

import {
    GET_REQUEST_ITEMS,
    GET_REQUEST_ITEM,
    STORE_REQUEST_ITEM,
    UPDATE_REQUEST_ITEM,
    DESTROY_REQUEST_ITEM,
} from "./actions.type";

import {
    SET_ERROR,
    SET_REQUEST_PAGINATION,
    SET_REQUEST_ITEMS,
    SET_REQUEST_ITEM,
    SET_PUSH_REQUEST_ITEM,
    SET_UPDATE_REQUEST_ITEM,
    SET_DESTROY_REQUEST_ITEM,
} from "./mutations.type";

const generateProp = (payload) => {
    let paths = payload.split('/')

    return paths.join('_');
}

const state = {
    pagination: {
        //
    },
    items: {
        //
    },
    item: {
        //
    },
};

const getters = {
    pagination: (state) => (path) => {
        return state.pagination[path];
    },
    items: (state) => (path) => {
        return state.items[path];
    },
    item: (state) => (path) => {
        return state.item[path];
    }
};

const mutations = {
    [SET_REQUEST_PAGINATION](state, payload) {
        state.pagination = lodash.assign(JSON.parse(JSON.stringify(state.pagination)), {
            [generateProp(payload.path)]: payload.pagination
        });
    },

    [SET_REQUEST_ITEMS](state, payload) {
        state.items = lodash.assign(JSON.parse(JSON.stringify(state.items)), {
            [generateProp(payload.path)]: payload.data
        });
    },

    [SET_REQUEST_ITEM](state, payload) {
        state.item = lodash.assign(JSON.parse(JSON.stringify(state.item)), {
            [generateProp(payload.path)]: payload.data
        });
    },

    [SET_PUSH_REQUEST_ITEM](state, payload) {
        state.items[generateProp(payload.path)].push(payload.data);
    },

    [SET_UPDATE_REQUEST_ITEM](state, payload) {
        lodash.forEach(state.items[generateProp(payload.path)], (item, key) => {
            if (item.id === payload.data.id) {
                state.items[generateProp(payload.path)][key] = payload.data;
            }
        })
    },

    [SET_DESTROY_REQUEST_ITEM](state, payload) {
        lodash.forEach(state.items[generateProp(payload.path)], (item, key) => {
            if (item.id === payload.id) {
                state.items[generateProp(payload.path)][key].id = null;
            }
        });
    },
};

const actions = {
    [GET_REQUEST_ITEMS](context, params) {
        if (params.is_api) {
            ApiService.setApi();
        } else {
            ApiService.init();
        }

        return new Promise((resolve, reject) => {
            ApiService.get(params.path, {params: params})
                .then(({data}) => {

                    context.commit(SET_REQUEST_ITEMS, {data : data.data, path : params.path});

                    if (data.pagination) {
                        context.commit(SET_REQUEST_PAGINATION, {pagination : data.pagination, path : params.path});
                    }

                    resolve(data.data);
                })
                .catch(error => {
                    context.commit(SET_ERROR, error.response.data);
                    reject(error.response);
                });
        }).catch((reject) => {
            console.log(reject)
        });
    },

    [GET_REQUEST_ITEM](context, params) {

        if (params.is_api) {
            ApiService.setApi();
        } else {
            ApiService.init();
        }

        return new Promise((resolve, reject) => {
            ApiService.get(params.path + '/' + params.id, {params: params})
                .then(({data}) => {
                    context.commit(SET_REQUEST_ITEM, {data : data.data, path : params.path});
                    resolve(data.data);
                })
                .catch(error => {
                    context.commit(SET_ERROR, error.response.data);
                    reject(error.response);
                });
        }).catch((reject) => {
            console.log(reject)
        });
    },

    [STORE_REQUEST_ITEM](context, params) {

        if (params.is_api) {
            ApiService.setApi();
        } else {
            ApiService.init();
        }

        return new Promise((resolve, reject) => {
            ApiService.store(params.path, params)
                .then(({data}) => {
                    if (!params.disable_push) {
                        context.commit(SET_PUSH_REQUEST_ITEM, {data : data.data, path : params.path});
                    }

                    resolve(data.data);
                    FormResponseService.success(data.message)
                })
                .catch(error => {
                    context.commit(SET_ERROR, error.response.data);
                    reject(error.response);
                });
        }).catch((reject) => {
            console.log(reject)
        });
    },

    [UPDATE_REQUEST_ITEM](context, params) {

        if (params.is_api) {
            ApiService.setApi();
        } else {
            ApiService.init();
        }

        return new Promise((resolve, reject) => {
            ApiService.update(params.path + '/' + params.id, params)
                .then(({data}) => {
                    context.commit(SET_UPDATE_REQUEST_ITEM, {data : data.data, path : params.path});
                    resolve(data.data);
                    FormResponseService.success(data.message)
                })
                .catch(error => {
                    context.commit(SET_ERROR, error.response.data);
                    reject(error.response);
                });
        }).catch((reject) => {
            console.log(reject)
        });
    },

    [DESTROY_REQUEST_ITEM](context, params) {

        if (params.is_api) {
            ApiService.setApi();
        } else {
            ApiService.init();
        }

        return new Promise((resolve, reject) => {
            ApiService.destroy(params.path + '/' + params.id, params)
                .then(({data}) => {
                    context.dispatch(GET_REQUEST_ITEMS, params)
                    resolve(data.data);
                    FormResponseService.success(data.message)
                })
                .catch(error => {
                    context.commit(SET_ERROR, error.response.data);
                    reject(error.response);
                });
        }).catch((reject) => {
            console.log(reject)
        });
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
